import { render } from "./WorksMain.vue?vue&type=template&id=0e1a4e21&scoped=true&bindings={\"message\":\"data\"}"
import script from "./WorksMain.vue?vue&type=script&lang=js"
export * from "./WorksMain.vue?vue&type=script&lang=js"

import "./WorksMain.vue?vue&type=style&index=0&id=0e1a4e21&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0e1a4e21"

export default script